import { DATA_AMOUNT } from '../consts';
import { language, propertyLanguage } from './language';

export const CURRENCIES = {
  EUR: '€',
  GBP: '£',
  ZAR: 'R',
};

export const createCurrencyFormatter = ({
  currency,
  language = 'en-GB',
} = {}) => (value) => {
  return new Intl.NumberFormat(language, {
    style: 'currency',
    // both maximumFractionDigits & minimumFractionDigits needs to be set
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    currency,
  }).format(value);
};

export const createFormatAmountInTemplate = ({
  currency,
  amountAttribute = DATA_AMOUNT,
}) => {
  const amountFormatter = createCurrencyFormatter({
    currency,
    language: propertyLanguage ?? language,
  });
  return (elementsSelector) => {
    elementsSelector.each((_, htmlElement) => {
      const element = $(htmlElement);
      const amount = element.attr(amountAttribute);
      const formattedAmount = amountFormatter(amount);
      element.text(formattedAmount);
    });
  };
};
